import React from 'react';
import { CheckCircle, Award, Users, TrendingUp } from 'lucide-react';

const CredentialsSection = () => {
  const credentials = [
    {
      icon: Award,
      title: 'Experiencia en Logística',
      description: 'Años de experiencia en courier internacional Miami-Costa Rica'
    },
    {
      icon: CheckCircle,
      title: 'Entregas Comprobadas',
      description: 'Miles de paquetes entregados exitosamente a todo Costa Rica'
    },
    {
      icon: Users,
      title: 'Clientes Satisfechos',
      description: '99.8% de satisfacción entre nuestros clientes activos'
    },
    {
      icon: TrendingUp,
      title: 'Servicio Confiable',
      description: 'Crecimiento constante gracias a recomendaciones de clientes'
    }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: 'var(--sendhapy-teal)' }}>
            Empresa profesional de courier
          </h2>
          <p className="text-xl text-gray-600">
            Tu mejor opción para envíos internacionales
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {credentials.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <div key={index} className="sendhapy-card text-center">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"
                     style={{ background: 'var(--sendhapy-teal)' }}>
                  <IconComponent size={32} style={{ color: 'var(--sendhapy-yellow)' }} />
                </div>
                <h3 className="font-bold text-lg mb-2" style={{ color: 'var(--sendhapy-teal)' }}>
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-xl text-gray-600 mb-6">
            ¿Listo para enviar tu próximo paquete?
          </p>
          <button 
            onClick={() => scrollToSection('contacto')}
            className="btn-sendhapy-primary"
          >
            Contactar Ahora
          </button>
        </div>
      </div>
    </section>
  );
};

export default CredentialsSection;
